import * as React from "react";
import { styled } from "@mui/material/styles";
import Link from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SidebarContext } from "./Sidebar";

export const Logo = React.forwardRef(
  (
    {
      children,
      img = "https://xsmbasketball.com/wp-content/uploads/thegem-logos/logo_033fe9e10695d37313702194ad3be9ed_2x.png",
    },
    ref
  ) => {
    const customizer = React.useContext(SidebarContext);
    const LogoStyled = styled(Link)(() => ({
      whiteSpace: "nowrap",
      overflow: customizer.isCollapse ? "hidden" : "visible",
      WebkitLineClamp: "1",
      fontSize: "2rem",
      padding: "10px 22px 0",
      textOverflow: "ellipsis",
    }));

    return (
      <LogoStyled href="/">
        {img == "" ? (
          <Typography variant="body">{children}</Typography>
        ) : (
          <Box
            component="img"
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
            src={img}
          />
        )}
      </LogoStyled>
    );
  }
);
